var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useTheme } from '@citrus/user';
import DragNDropDroppedItemCitron from './DragNDropDroppedItemCitron';
import DragNDropDroppedItemLegacy from './DragNDropDroppedItemLegacy';
/** DISPLAY NAME: &lt;DragNDrop.DroppedItem&gt; */
var DragNDropDroppedItem = React.forwardRef(function (props, ref) {
    var isCitron = useTheme().citrus2022;
    return isCitron ? React.createElement(DragNDropDroppedItemCitron, __assign({}, props)) : React.createElement(DragNDropDroppedItemLegacy, __assign({}, props));
});
DragNDropDroppedItem.defaultProps = {
    __TYPE: 'DragNDropDroppedItem',
};
export default DragNDropDroppedItem;
